
  (() => {
    const section = document.querySelector('.be-article-v3');
    const article = section && section.querySelector('.be-article-v3');
    if (!section || !article || article.dataset.enhanced === 'true') return;
    article.dataset.enhanced = 'true';

    const body = section.querySelector('.be-article-v3__body');
    // Keep one player: approved mobile header, desktop article column.
    const video = section.querySelector('.be-article-video');
    const desktopHome = body && body.querySelector('[data-article-video-desktop]');
    if (desktopHome && video) {
      const mobileHome = document.createComment('article-video-mobile-position');
      video.before(mobileHome);
      const desktop = window.matchMedia('(min-width: 821px)');
      const placeVideo = () => {
        const parent = desktop.matches ? desktopHome.parentNode : mobileHome.parentNode;
        const before = desktop.matches ? desktopHome : mobileHome.nextSibling;
        if (before === video) return;
        if (typeof parent.moveBefore === 'function') parent.moveBefore(video, before);
        else parent.insertBefore(video, before);
      };
      placeVideo();
      desktop.addEventListener('change', placeVideo);
    }

    const layout = section.querySelector('[data-article-layout]');
    const tocTemplate = section.querySelector('[data-article-toc-template]');
    if (tocTemplate) {
      if (body && Array.from(body.querySelectorAll('h2,h3')).some((heading) => heading.textContent.trim())) {
        tocTemplate.replaceWith(tocTemplate.content.cloneNode(true));
      } else {
        tocTemplate.remove();
      }
    }
    const desktopToc = section.querySelector('[data-article-toc]');
    const mobileToc = section.querySelector('[data-article-mobile-toc]');
    const desktopNav = section.querySelector('[data-article-toc-desktop]');
    const mobileNav = section.querySelector('[data-article-toc-mobile]');
    const headings = body ? Array.from(body.querySelectorAll('h2,h3')).filter((heading) => heading.textContent.trim()) : [];
    const sectionHeadings = headings.filter((heading) => heading.tagName === 'H2');
    const tocHeadings = sectionHeadings.length ? sectionHeadings : headings;
    const usedIds = new Set(Array.from(document.querySelectorAll('[id]')).map((element) => element.id).filter(Boolean));

    const slugify = (value) => value
      .normalize('NFKD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9㐀-鿿]+/g, '-')
      .replace(/^-+|-+$/g, '');

    const uniqueId = (base, index) => {
      const root = base || `section-${index + 1}`;
      let candidate = root;
      let suffix = 2;
      while (usedIds.has(candidate)) {
        candidate = `${root}-${suffix}`;
        suffix += 1;
      }
      usedIds.add(candidate);
      return candidate;
    };

    const manualLinks = desktopNav ? Array.from(desktopNav.querySelectorAll('a[href^="#"]')) : [];
    manualLinks.forEach((link, index) => {
      const requestedId = decodeURIComponent(link.getAttribute('href').slice(1));
      if (!requestedId || document.getElementById(requestedId) || !tocHeadings[index]) return;
      if (tocHeadings[index].id) usedIds.delete(tocHeadings[index].id);
      tocHeadings[index].id = uniqueId(requestedId, index);
    });

    headings.forEach((heading, index) => {
      if (heading.id) {
        usedIds.add(heading.id);
        return;
      }
      heading.id = uniqueId(slugify(heading.textContent.trim()), index);
    });

    const appendLinks = (nav) => {
      if (!nav || nav.querySelector('a')) return;
      tocHeadings.forEach((heading) => {
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        nav.appendChild(link);
      });
    };

    appendLinks(desktopNav);
    appendLinks(mobileNav);

    const tocLinks = desktopNav ? Array.from(desktopNav.querySelectorAll('a[href^="#"]')) : [];
    if (tocLinks.length) {
      if (layout) layout.classList.remove('be-article-v3__layout--body-only');
      if (desktopToc) desktopToc.hidden = false;
      if (mobileToc) mobileToc.hidden = false;
      if (mobileNav) {
        mobileNav.addEventListener('click', (event) => {
          if (event.target.closest('a') && mobileToc) mobileToc.open = false;
        });
      }
    } else {
      if (layout) layout.classList.add('be-article-v3__layout--body-only');
      if (desktopToc) desktopToc.remove();
      if (mobileToc) mobileToc.remove();
    }

    const useSharedToc = !/^de(?:-|$)/i.test(document.documentElement.lang || '');
    const trackedHeadings = tocLinks
      .map((link) => document.getElementById(decodeURIComponent(link.getAttribute('href').slice(1))))
      .filter(Boolean);
    const progress = section.querySelector('[data-reading-progress]');
    let scrollPending = false;
    const updateScroll = () => {
      scrollPending = false;
      let active = trackedHeadings[0] || null;
      if (!useSharedToc) trackedHeadings.forEach((heading) => {
        if (heading.getBoundingClientRect().top <= 132) active = heading;
      });
      let percent = 0;
      if (progress) {
        const rect = article.getBoundingClientRect();
        const total = Math.max(1, article.offsetHeight - window.innerHeight);
        percent = Math.max(0, Math.min(100, (-rect.top / total) * 100));
      }
      if (!useSharedToc) tocLinks.forEach((link) => {
        link.classList.toggle('is-active', !!active && link.getAttribute('href') === `#${active.id}`);
      });
      if (progress) progress.style.width = `${percent}%`;
    };
    const scheduleScroll = () => {
      if (scrollPending) return;
      scrollPending = true;
      requestAnimationFrame(updateScroll);
    };
    document.addEventListener('scroll', scheduleScroll, { passive:true });
    window.addEventListener('resize', scheduleScroll, { passive:true });
    scheduleScroll();
    document.dispatchEvent(new CustomEvent('be:toc-ready'));
  })();



(function(){var source=document.getElementById('be-google-source')?.closest('.shopify-section');var previous=source&&source.previousElementSibling;var subscribe=previous&&previous.querySelector('[data-article-subscribe]');var block=source&&source.querySelector('.be-preferred-source');if(subscribe&&block){subscribe.after(block);}var body=previous&&previous.querySelector('.be-article-v3__body');var headings=body&&body.querySelectorAll('h2');if(subscribe&&headings&&headings.length>1){var target=headings[1];var parent=target.parentElement;if(parent!==body&&parent.matches('section')&&parent.querySelector('h2')===target){target=parent;}target.before(subscribe);subscribe.classList.add('be-field-notes-inline');}})();
(function(){var root=document.getElementById("be-google-source");if(!root)return;var slot=root.querySelector("[google-add-preferred-source-btn]");if(!slot)return;function load(){if(window.__bePreferredSourceLoading)return;window.__bePreferredSourceLoading=!0;var s=document.createElement("script");s.async=!0;s.src="https://news.google.com/swg/js/v1/publisher.js";document.head.appendChild(s)}if("IntersectionObserver"in window){var io=new IntersectionObserver(function(e){for(var k=0;k<e.length;k++){if(e[k].isIntersecting){io.disconnect();load();return}}},{rootMargin:"800px 0px"});io.observe(root)}else{window.addEventListener("load",function(){setTimeout(load,1500)})}})();

/* 0928 BE. 产品卡 C 样式（Mel 选定）：只作用于链接到 /products/ 的 .be-card；实时读商品图与价格；GA4 点击事件带卡位序号 */
(function(){
  var art=document.querySelector('.be-article-v3__body')||document.querySelector('.be-art');if(!art)return;
  var cards=[].slice.call(document.querySelectorAll('.be-art .be-card')).filter(function(c){var a=c.querySelector('a[href*="/products/"]');return !!a;});
  if(!cards.length)return;
  var de=(document.documentElement.lang||'').toLowerCase().indexOf('de')===0;
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  function money(cents){if(!de&&window.BELiveProductPricing1003)return window.BELiveProductPricing1003.format(cents,cur);try{return new Intl.NumberFormat(de?'de-DE':'en-IE',Object.assign({style:'currency',currency:cur},de?{maximumFractionDigits:0}:{})).format(cents/100)}catch(e){return ''}}
  /* Mel 0928：图 → 第一张产品卡 → Field note，Field note 紧跟第一张卡 */
  try{var sub=document.querySelector('.be-field-notes-inline[data-article-subscribe]')||document.querySelector('.be-article-v3__body [data-article-subscribe]');if(sub&&!cards[0].contains(sub)){cards[0].after(sub)}}catch(e){}
  cards.forEach(function(card,i){
    var a=card.querySelector('a[href*="/products/"]');var href=a.getAttribute('href');var m=href.match(/\/products\/([^/?#]+)/);if(!m)return;var handle=m[1];
    var tEl=card.querySelector('.be-card-ttl');var title=tEl?tEl.textContent.trim():'';
    card.addEventListener('click',function(event){if(!event.target.closest('a[href*="/products/"]'))return;try{if(!window.Shopify||!Shopify.customerPrivacy||Shopify.customerPrivacy.analyticsProcessingAllowed()!==true)return}catch(e){return}var p={card_slot:i+1,product_handle:handle,article:location.pathname};try{window.gtag&&gtag('event','blog_product_card_click',p)}catch(e){}try{(window.dataLayer=window.dataLayer||[]).push(Object.assign({event:'blog_product_card_click'},p))}catch(e){}});
    function fill(){fetch(root+'products/'+handle+'.js',{credentials:'same-origin'}).then(function(r){if(!r.ok)throw new Error('Product request failed');return r.json()}).then(function(p){
      if(!card.isConnected||!p||typeof p.featured_image!=='string'||!p.featured_image||typeof p.price!=='number')return;
      var price=money(p.price);if(!price)return;
      var img=p.featured_image;
      var restoreCardFocus=card.contains(document.activeElement);
      var cardNotes=[].slice.call(card.children).filter(function(node){return node.tagName==='P'});
      var fallbackHeaderHeight=0;
      if(cardNotes.length){var box=card.getBoundingClientRect(),noteBox=cardNotes[0].getBoundingClientRect(),skin=getComputedStyle(card);fallbackHeaderHeight=Math.max(0,noteBox.top-box.top-(parseFloat(skin.borderTopWidth)||0)-(parseFloat(skin.rowGap)||0)+(parseFloat(skin.paddingBottom)||0));}
      /* 1011: the button keeps the label the page was served with, so it does not change after the price loads */
      var btnEl=card.querySelector('.be-card-btn'),btnTxt=(btnEl&&btnEl.textContent.trim())||'SHOP NOW';
      card.classList.add('be-pcard');
      card.innerHTML='<a class="be-pcard__link" href="'+esc(href)+'"><span class="be-pcard__ph" aria-hidden="true"></span><span><span class="be-pcard__n">'+esc(p.title||title)+'</span><span class="be-pcard__m">'+(de?'Mit Stone Origin Record':'Stone Origin Record included')+'</span></span><span class="be-pcard__row"><span class="be-pcard__p">'+esc(price)+'</span><span class="be-pcard__b">'+esc(btnTxt)+'</span></span></a>';
      if(cardNotes.length){var productLink=card.querySelector('a.be-pcard__link');if(fallbackHeaderHeight){productLink.style.setProperty('--be-pcard-initial-header',fallbackHeaderHeight+'px');card.setAttribute('data-be-pcard-initial-breakpoint',window.matchMedia('(max-width:600px)').matches?'mobile':'desktop');}cardNotes.forEach(function(note){card.appendChild(note)}); }
      if(restoreCardFocus)card.querySelector('a.be-pcard__link').focus({preventScroll:true});
      var el=document.createElement('img');el.className='be-pcard__img';el.alt=p.title||title;el.loading='lazy';el.decoding='async';el.width=72;el.height=72;el.src=(img.indexOf('//')===0?'https:'+img:img)+(img.indexOf('?')>0?'&':'?')+'width=260';card.querySelector('.be-pcard__ph').appendChild(el);
    }).catch(function(){/* Keep the original title and product link when live data is unavailable. */})}
    if('IntersectionObserver' in window){var io=new IntersectionObserver(function(e){for(var k=0;k<e.length;k++){if(e[k].isIntersecting){io.disconnect();fill();return}}},{rootMargin:'600px 0px'});io.observe(card)}else{fill()}
  });
})();
